import axiosInstance from 'api/axiosInstance'

export const getBlockedUsers = async (
    filter: string,
    sort: string = 'asc',
    currentPage: number = 1
) => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: `/api/user/blocked-users?sort_by=${filter}&sort_value=${sort}&page=${currentPage}`
        })
        return {
            nextCursor:
                currentPage < data?.meta?.last_page
                    ? currentPage + 1
                    : undefined,
            prevCursor: currentPage > 1 ? currentPage - 1 : undefined,
            page: {
                data
            }
        }
    } catch (error) {
        console.error('Error:', error)
    }
}
export const getRestrictedUsers = async (
    filter: string,
    sort: string = 'asc',
    currentPage: number = 1
) => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: `/api/user/restricted-users?sort_by=${filter}&sort_value=${sort}&page=${currentPage}`
        })
        return {
            nextCursor:
                currentPage < data?.meta?.last_page
                    ? currentPage + 1
                    : undefined,
            prevCursor: currentPage > 1 ? currentPage - 1 : undefined,
            page: {
                data
            }
        }
    } catch (error) {
        console.error('Error:', error)
    }
}

export const putDiscovery = async (value: boolean) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/disabled_discovery',
        data: {
            disabled_discovery: value
        }
    })

    return data
}

export interface WatermarkSettingsPayload {
    watermark_photos?: boolean
    watermark_videos?: boolean
}

export const putWatermarkSettings = async (
    payload: WatermarkSettingsPayload
) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/watermark-settings',
        data: payload
    })

    return data
}